/**
 * SearchBar Component
 *
 * Acts as a trigger for the global Command Palette (Cmd+K).
 * Displays a search-style input that opens the palette on click/focus.
 *
 * @module SearchBar
 */

import React from 'react';
import { IconSearch } from '@tabler/icons-react';
import { useCommandPalette } from '../../ui/command-palette';

/**
 * SearchBar - Command palette trigger
 */
const SearchBar = () => {
  const { setOpen } = useCommandPalette();

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div className="relative">
      {/* Search Icon */}
      <IconSearch
        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-tertiary"
        aria-hidden="true"
      />

      {/* Trigger button styled as input */}
      <button
        type="button"
        onClick={handleOpen}
        className="w-full pl-9 pr-16 py-2 bg-surface-2 border border-glass-border text-sm text-text-tertiary text-left focus:border-accent focus:ring-2 focus:ring-accent-muted focus:outline-none cursor-pointer"
        aria-label="Open command palette"
      >
        Search...
      </button>

      {/* Keyboard shortcut badge */}
      <kbd className="absolute right-3 top-1/2 -translate-y-1/2 border border-glass-border bg-surface-3 px-1.5 py-0.5 text-[10px] font-medium text-text-tertiary pointer-events-none select-none">
        ⌘K
      </kbd>
    </div>
  );
};

export default React.memo(SearchBar);
